import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { breakpoint } from 'src/styles/dontgiftguide.styles';

export const container = css`
  position: relative;
  height: 230px;

  ${mediaQuery(
    { min: breakpoint },
    css`
      height: 330px;
    `,
  )}

  img {
    height: 100%;
  }
`;
